import * as Rx from 'rxjs';
import * as RxOp from 'rxjs/operators';
import { fetchPeriscopeDashboardIFrameUrl } from '../../utils/api/client';
import { caughtError } from '../../utils/api/errorHandler';
import { getAccessToken, getPosApiUrl } from '../../utils/state';

import {
  getPeriscopeDashboardIFrameUrlSucceeded,
  reportingAlertBarAction,
  getPeriscopeDashboardIFrameUrlFailed,
  REQUEST_PERISCOPE_DASHBOARD_IFRAME_URL,
} from './Reporting.state';

export const caughtReportingErrorCallback = (state) =>
  caughtError(reportingAlertBarAction, 'Reporting Error:', state);

const fetchPeriscopeDashboardIFrameUrlParams = (state) => ({
  url: getPosApiUrl(state),
  token: getAccessToken(state),
  method: 'GET',
});

const requestPeriscopeDashboardEpic = (action$, state$) =>
  action$.ofType(REQUEST_PERISCOPE_DASHBOARD_IFRAME_URL).pipe(
    RxOp.flatMap(() =>
      Rx.from(
        fetchPeriscopeDashboardIFrameUrl(
          fetchPeriscopeDashboardIFrameUrlParams(state$.value),
        ),
      ).pipe(
        RxOp.flatMap((response) =>
          Rx.of(
            getPeriscopeDashboardIFrameUrlSucceeded({ url: response.data }),
          ),
        ),
        RxOp.catchError((err) =>
          caughtReportingErrorCallback(state$.value)(
            err,
            getPeriscopeDashboardIFrameUrlFailed(err.message),
          ),
        ),
      ),
    ),
  );

export default requestPeriscopeDashboardEpic;
